import cn from 'classnames'
import {useId} from 'react'
import type {FinanceStack} from 'slices/RoiCalculator/types'

export type FinanceStackOption = {
  value: FinanceStack
  label: string
}

export type FinanceStackSelectProps = {
  label: string
  options: FinanceStackOption[]
  value: FinanceStack
  onChange: (value: FinanceStack) => void
}

export const FinanceStackSelect = ({label, options, value, onChange}: FinanceStackSelectProps) => {
  const groupName = useId()

  return (
    <fieldset className="flex flex-col gap-3.5">
      <legend className="pb-3.5 text-16 leading-none text-moss-grey-550">{label}</legend>
      <div className="flex flex-col gap-2.5">
        {options.map((option) => {
          const isSelected = option.value === value

          return (
            <label
              key={option.value}
              className={cn(
                'flex cursor-pointer items-center gap-3 rounded-lg border px-4 py-3 text-16 leading-snug',
                'has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-green-dark',
                isSelected
                  ? 'border-green-dark bg-moss-blue-light/30 font-medium text-moss-black'
                  : 'border-moss-black/10 bg-moss-white text-moss-grey-550 hover:border-moss-black/20',
              )}
            >
              <input
                type="radio"
                name={groupName}
                value={option.value}
                checked={isSelected}
                onChange={() => onChange(option.value)}
                className="sr-only"
              />
              <span
                aria-hidden="true"
                className={cn(
                  'flex size-[18px] shrink-0 items-center justify-center rounded-full border-2',
                  isSelected ? 'border-green-dark' : 'border-moss-black/20',
                )}
              >
                {isSelected && <span className="size-2.5 rounded-full bg-green-dark" />}
              </span>
              {option.label}
            </label>
          )
        })}
      </div>
    </fieldset>
  )
}
